import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import BInputField from '@/components/general/BInputField.vue';
import BButton from '@/components/general/BButton.vue';
import IconEmail from '@/components/general/icons/IconEmail.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BForgotPassword',
  emits: ['gotoLogin'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var sdk = useSdk();
    var notifier = useNotifier();
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var email = ref('');
    var hasError = ref(true);
    var resetSent = ref(false);
    function reset() {
      return _reset.apply(this, arguments);
    }
    function _reset() {
      _reset = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return sdk.account.resetUserPassword({
                email: email.value
              });
            case 1:
              resetSent.value = true;
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              notifier.showMessage({
                content: t('auth.resetPassword.error'),
                type: 'error'
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }));
      return _reset.apply(this, arguments);
    }
    function gotoLogin() {
      resetSent.value = false;
      emit('gotoLogin');
    }
    function formError(e) {
      hasError.value = e;
    }
    return {
      __sfc: true,
      emit: emit,
      sdk: sdk,
      notifier: notifier,
      t: t,
      email: email,
      hasError: hasError,
      resetSent: resetSent,
      reset: reset,
      gotoLogin: gotoLogin,
      formError: formError,
      BInputField: BInputField,
      BButton: BButton,
      IconEmail: IconEmail
    };
  }
});